import { HandThumbUpIcon, UserCircleIcon } from '@heroicons/react/20/solid';
import { ChatBubbleLeftIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import {
  FaceFrownIcon,
  FaceSmileIcon,
  FireIcon,
  HeartIcon,
  PaperClipIcon,
  XMarkIcon,
  TrashIcon,
  PaperAirplaneIcon,
  PinIcon,
} from '@heroicons/react/20/solid'
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'

// Add CSS for custom scrollbar
const scrollbarStyles = `
  /* Custom scrollbar styles */
  .hide-scrollbar::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }
  
  .hide-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .hide-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 10px;
  }
  
  .hide-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }
`;
import LoadingComponent from './loading';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import ProductHub from './producthub';

const moods = [
  { name: 'Excited', value: 'excited', icon: FireIcon, iconColor: 'text-white', bgColor: 'bg-red-500' },
  { name: 'Loved', value: 'loved', icon: HeartIcon, iconColor: 'text-white', bgColor: 'bg-pink-400' },
  { name: 'Happy', value: 'happy', icon: FaceSmileIcon, iconColor: 'text-white', bgColor: 'bg-green-400' },
  { name: 'Sad', value: 'sad', icon: FaceFrownIcon, iconColor: 'text-white', bgColor: 'bg-yellow-400' },
  { name: 'Thumbsy', value: 'thumbsy', icon: HandThumbUpIcon, iconColor: 'text-white', bgColor: 'bg-blue-500' },
  { name: 'I feel nothing', value: null, icon: XMarkIcon, iconColor: 'text-gray-400', bgColor: 'bg-transparent' },
]

import { useNavigate } from 'react-router-dom';
import { UserGroupIcon } from '@heroicons/react/24/solid';
import { getProfilePicSrc } from '../utils/mediaUrl';






function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

// Function to parse content - only handles <text> as bold titles on separate lines
const parseContent = (content) => {
  if (!content) return content;

  // Split content by <...> patterns
  const parts = content.split(/(<[^>]+>)/g);

  return parts.map((part, index) => {
    // Check if this part is wrapped in <>
    if (part.startsWith('<') && part.endsWith('>')) {
      // Remove the <> and make it a bold title on its own line
      const titleText = part.slice(1, -1);
      return (
        <h4 key={index} className="font-bold text-gray-900 text-base mb-2 mt-4 first:mt-0">
          {titleText}
        </h4>
      );
    } else if (part.trim()) {
      // Regular text
      return (
        <p key={index} className="text-gray-700 text-sm leading-relaxed mb-2 whitespace-pre-wrap">
          {part}
        </p>
      );
    }
    return null;
  }).filter(Boolean);
};




export default function Feed() {



  const [post, setPost] = useState(false)
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    tags: 'Everyone',
    type: 'news',
    pinned: 0,
    shout: []
  });
  const [posts, setPosts] = useState([])
  const [makeComment, setMakeComment] = useState('')
  const [newComment, setNewComment] = useState(null)
  const [selected, setSelected] = useState(moods[5])
  const [postShow, setPostShow] = useState(null)
  const [loading, setLoading] = useState(false)
  const [staff, setStaff] = useState([])
    const [commentContent, setCommentContent] = useState('');

  const [showComments, setShowComments] = useState(null)
  const [selectedTab, setSelectedTab] = useState('Everyone')
  const [comment, setComment] = useState('')
  const [showLikes, setShowLikes] = useState(false)

  const token = localStorage.getItem('token');

  const user = useContext(AuthContext);

  const tabs = user.access === 'staff' 
    ? [
        { name: 'Team', tag: 'Team', current: false },
        { name: 'Everyone', tag: 'Everyone', current: true },
        { name: 'Product Hub', tag: 'Product Hub', current: false },
      ]
    : [
        { name: 'Team', tag: 'Team', current: false },
        { name: 'Managers', tag: 'Managers', current: false },
        { name: 'Everyone', tag: 'Everyone', current: true },
        { name: 'Product Hub', tag: 'Product Hub', current: false },
      ];

  console.log(selectedTab)

  const mobileTabIcons = {
    Team: UserGroupIcon,
    Managers: UserCircleIcon,
    Everyone: HandThumbUpIcon,
    'Product Hub': CheckCircleIcon,
  };


  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'select-multiple') {
      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOptions, // Store selected options as an array
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };



  const submitPost = async (e) => {
    e.preventDefault();
    console.log(formData.shout)

    // if tab is Team then add Role to Role 



    const form = {
      Title: formData.title,
      Content: formData.content,
      Tags: formData.tags,
      Type: formData.type,
      StaffId: user.id,
      StaffEmail: user.email,
      StaffName: user.name,
      Pinned : formData.pinned,
      Shouts: formData.shout

    }

    try {
      // Post form data to the backend
      const response = await fetch('https://api.insightos.co.uk/api/posts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',

        },
        credentials : 'include',

        body: JSON.stringify(form),
      });

      if (!response.ok) {
        throw new Error('Failed to submit the form. Please try again.');
      }

      // Clear the form and show a success message
      setFormData({
        title: '',
        content: '',
        tags: '',
        type: 'news',
        pinned: 0,
        shout: []
      });
      setPost(false)
    } catch (error) {
      console.error(error)
    }
  }


  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await fetch('https://api.insightos.co.uk/api/staff', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',


        });

        if (!response.ok) {
          throw new Error('Failed to fetch staff data');
        }

        const data = await response.json();

        setStaff(data.data);

        console.log(data);

      } catch (error) {

        console.error(error);

      }

    }

    fetchStaff();


  }, [post])





  const handleTabClick = (tab) => {
    // Update the selected tab
    setSelectedTab(tab);
    setPostShow(null)

    // If Product Hub tab is selected, don't fetch posts
    if (tab.name === 'Product Hub') {
      return;
    }

    // Fetch the posts for the selected tab

    const fetchPosts = async (tab) => {
      try {
        // Fetch posts for the selected tab
        const response = await fetch(`https://api.insightos.co.uk/api/posts/${tab.name}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',

        });

        if (!response.ok) {
          throw new Error('Failed to fetch posts');
        }

        const postsData = await response.json();

        // Fetch staff data
        const response2 = await fetch('https://api.insightos.co.uk/api/staff', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',

        });

        if (!response2.ok) {
          throw new Error('Failed to fetch staff data');
        }

        const response3 = await fetch('https://api.insightos.co.uk/api/clockins', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',


        })

        if (!response3.ok) {
          throw new Error('Failed to fetch clockins data');
        }

        const clockinsData = await response3.json();









        const staffData = await response2.json();

        // Process staff to convert ProfilePic - Fixed version
        const processedStaff = staffData.data.map((person) => ({
          ...person,
          ProfilePic: getProfilePicSrc(person) || '',
        }));

        // sort posts data by .Pinned === 1 and then by CreatedAt with latest first
        postsData.data.sort((a, b) => {
          if (a.Pinned > b.Pinned) return -1;
          if (a.Pinned < b.Pinned) return 1;
          if (a.CreatedAt > b.CreatedAt) return -1;
          if (a.CreatedAt < b.CreatedAt) return 1;
          return 0;
        }
        );


        // Merge posts with staff ProfilePic by matching StaffId
        const mergedPosts = postsData.data.map((post) => {
          const staff = processedStaff.find((person) => String(person.id) === String(post.StaffId));
          const clockin = clockinsData.data.find((clockin) => clockin.StaffId === post.StaffId)

          // if there is a record in clockinsData that matches the StaffId, add it as ClockedIn = 1 else ClockedIn = 0
          const clockedIn = clockin ? 1 : 0;

          // always put Pinned === 1 and sort by CreatedAt


          // get comments for each post, dedupe by CommentId, and then match StaffId to ProfilePic
          const commentMap = new Map();
          post.comments.forEach((comment) => {
            const key = comment.CommentId ?? `${comment.StaffId}-${comment.CreatedAt}-${comment.Content}`;
            if (!commentMap.has(key)) {
              commentMap.set(key, comment);
            }
          });

          const comments = Array.from(commentMap.values()).map((comment) => {
            const staff = processedStaff.find((person) => String(person.id) === String(comment.StaffId));
            return {
              ...comment,
              ProfilePic: staff ? getProfilePicSrc(staff) : '',
            };
          });

          // Dedupe likes because API joins can return repeated like rows after comment updates.
          const likeMap = new Map();
          (Array.isArray(post.likes) ? post.likes : []).forEach((like) => {
            const key = like.LikeId ?? `${like.StaffId}-${like.CreatedAt || ''}`;
            if (!likeMap.has(key)) {
              likeMap.set(key, like);
            }
          });
          const likes = Array.from(likeMap.values());

          return {
            ...post,
            ProfilePic: staff ? getProfilePicSrc(staff) : '', // Add ProfilePic
            Role: staff ? staff.Role : null,            // Add Role
            ManagementLevel: staff ? staff.ManagementLevel : null, // Add ManagementLevel
            ClockedIn: clockedIn,
            comments: comments,
            likes: likes,




          };
        });

        // merge Clockins.StaffId with staff.id
        // Update state with processed posts
        setPosts(mergedPosts);


        console.log(mergedPosts); // Log merged posts for debugging
      } catch (error) {
        console.error(error);
      }
    };

    fetchPosts(tab);

  };

  useEffect(() => {
    handleTabClick(selectedTab);

    // reload handleTabClick every 10 seconds

    const intervalId = setInterval(() => {
      handleTabClick(selectedTab);
    }, 10000);

    return () => clearInterval(intervalId);




  }, [selectedTab]);




  useEffect(() => {

    const tab = {
      name: 'Everyone',
    }

    handleTabClick(tab);


  }, [])



  const handleProfileClick = (post) => {

    // find all the posts with the same StaffId using the post.StaffId

    let staffPosts = posts.filter((p) => p.StaffId === post.StaffId)

    setPosts(staffPosts)
    setPostShow(`Posts by ${post.StaffName}`)


  }

  console.log(makeComment)


  const handleCommentSubmit = async (post) => {

    console.log(commentContent)

    // Use state `comment` for the content
    const newComment = {
      Comment: commentContent, // Assuming `comment` is the state holding the comment input
      PostId: post.PostId,
      StaffId: user.id,
      StaffName: user.name,
      StaffEmail: user.email,
    };

    try {
      const response = await fetch(`https://api.insightos.co.uk/api/comments/${post.PostId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(newComment),
      });

      if (!response.ok) {
        throw new Error('Failed to submit comment');
      }

      const data = await response.json();

      console.log(data);

      // Clear the comment input and refresh
      setCommentContent(''); // Reset the comment input field
      setNewComment(null); // Close the comment UI
      handleTabClick(selectedTab);
    } catch (error) {
      console.error(error);
    }
  };


  const handleLike = async (post) => {

    const newLike = {
      PostId: post.PostId,
      StaffId: user.id,
      StaffEmail: user.email,
      StaffName: user.name
    };

    console.log("newLike", newLike);

    try {
      const response = await fetch(`https://api.insightos.co.uk/api/likes/${post.PostId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',

        body: JSON.stringify(newLike),
      });


      if (!response.ok) {
        throw new Error('Failed to like post');
      }

      const data = await response.json();

      console.log(data);

      // Refresh the posts

      handleTabClick(selectedTab);

    } catch (error) {
      console.error(error);
    }

  }




  const handleDeleteComment = async (comment) => {

    console.log(comment);

    const id = comment.CommentId;

    try {
      const response = await fetch(`https://api.insightos.co.uk/api/deletecomment/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to delete comment');
      }

      const data = await response.json();

      console.log(data);

      // Refresh the posts

      handleTabClick(selectedTab);

    } catch (error) {

      console.error(error);

    }

  }


  const toggleShout = (staffName) => {
    // Check if the staffName is already in the shout array
    if (formData.shout.includes(staffName)) {
      // Remove the staffName from the shout array
      setFormData((prevData) => ({
        ...prevData,
        shout: prevData.shout.filter((name) => name !== staffName),
      }));
    } else {
      // Add the staffName to the shout array
      setFormData((prevData) => ({
        ...prevData,
        shout: [...prevData.shout, staffName],
      }));
    }
  }




  const profileShow = (staffName) => {

    const navigate = useNavigate();

    // Filter the staff array to find the person with the matching staffName
    const person = staff.find((post) => post.StaffName === staffName);

    if (person) {
      // Navigate to the profile page and pass the person data as state
      navigate('/profilepage', { state: { person } });
    } else {
      console.error('Person not found');
    }
  };










  return (
    <div
      className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-sky-50 to-indigo-100 pb-28 sm:pb-0"
    >
      {/* Add custom scrollbar styles */}
      <style dangerouslySetInnerHTML={{ __html: scrollbarStyles }} />
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
          <LoadingComponent />
        </div>
      )}
      
      {/* Header Section with improved styling */}
        <div
    className="w-full bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl border-b border-indigo-200/60 shadow-[0_12px_30px_rgba(99,102,241,0.2)] px-2 py-3 sm:px-4 md:flex md:items-center md:justify-between"
        >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img src="/2.png" alt="StaffShark" className="h-8 rounded-full bg-gray-900 w-auto mr-3" />
            <h2 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 font-bebas sm:text-2xl sm:tracking-tight">
              News Feed
            </h2>
          </div>
          {user.access !== 'staff' && (
            <div className="md:hidden">
              <button onClick={() => setPost(true)}
                type="button"
                className="inline-flex items-center rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-3 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-950/40 transition-all hover:from-indigo-800/95 hover:to-indigo-600/95 focus:outline-none"
              >
                Create Post
              </button>
            </div>
          )}
        </div>
        
        {user.access !== 'staff' && (
          <div className="mt-4 hidden md:flex md:ml-4 md:mt-0">
            <button onClick={() => setPost(true)}
              type="button"
              className="inline-flex items-center rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-3 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-950/40 transition-all hover:from-indigo-800/95 hover:to-indigo-600/95 focus:outline-none"
            >
              Create Post
            </button>
          </div>
        )}
      </div>
      {/* Mobile quick access removed (Product Hub back in bottom bar) */}

      {/* Tabs section with improved mobile responsiveness */}
      <div className="mx-3 mb-6 hidden w-auto overflow-hidden rounded-3xl border border-white/35 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl sm:block sm:mx-4">
        {/* Scrollable tabs for all screens */}
        <div className="border-b border-indigo-200/60 w-full">
          <div className="px-0 sm:px-4 overflow-x-auto hide-scrollbar w-full">
            <nav className="flex -mb-px py-1 w-full" aria-label="Tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => handleTabClick(tab)}
                  className={classNames(
                    tab.name === selectedTab.name
                      ? 'border-indigo-500 text-indigo-900 bg-white/80 shadow-[0_8px_20px_rgba(15,23,42,0.1)]'
                      : 'border-transparent text-indigo-700 hover:border-indigo-300 hover:text-indigo-900 hover:bg-white/60',
                    'whitespace-nowrap py-3 px-4 font-semibold border-b-2 text-sm flex-shrink-0 rounded-t-xl transition-all'
                  )}
                >
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>
        </div>
      </div>
          {post && (
        <div className="mx-3 mb-6 w-full overflow-hidden rounded-3xl border border-white/35 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 shadow-[0_18px_40px_rgba(99,102,241,0.22)] backdrop-blur-xl pb-28 sm:mx-auto sm:max-w-4xl sm:pb-0">
          {/* Form Header */}
          <div className="flex items-center justify-between bg-gradient-to-r from-indigo-900 via-sky-600 to-emerald-500 px-6 py-4">
            <h2 className="text-xl font-bold text-white">Create a New Post</h2>
            <button
              type="button"
              onClick={() => setPost(false)}
              className="text-white hover:text-gray-200"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          {/* Form */}
          <div className="p-6">
            <form onSubmit={submitPost} className="space-y-5">
            {/* Title */}
            <div>
              <label htmlFor="title" className="block text-sm font-semibold text-gray-700 mb-1">
                Title
              </label>
              <input onChange={handleChange}
                type="text"
                name="title"
                id="title"
                autoComplete="off"
                required
                className="w-full rounded-2xl border border-white/45 bg-white/90 px-4 py-2 text-gray-900 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              />
            </div>

            {/* Content */}
            <div>
              <label htmlFor="content" className="block text-sm font-semibold text-gray-700 mb-1">
                Content
              </label>
              <textarea onChange={handleChange}
                id="content"
                name="content"
                required
                rows="4"
                className="w-full rounded-2xl border border-white/45 bg-white/90 px-4 py-2 text-gray-900 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              />
            </div>

            {/* Tags */}
            <div>
              <label htmlFor="tags" className="block text-sm font-semibold text-gray-700 mb-1">
                Tags
              </label>
              <select onChange={handleChange}
                id="tags"
                name="tags"
                required
                className="w-full rounded-2xl border border-white/45 bg-white/90 px-4 py-2 text-gray-900 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              >
                <option value="Everyone">Everyone</option>
                <option value="Team">My Team</option>
                <option value="Managers">Managers</option>
              </select>
            </div>
            <div>
              <div>
                <div className="space-y-2">
                  {staff.map((staffMember) => (
                    <button
                      type="button"
                      key={staffMember.id}
                      onClick={() => toggleShout(staffMember.Name)}
                        className={`block w-full text-left p-2 rounded-xl border transition-all ${formData.shout.includes(staffMember.Name)
                          ? 'bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 border-white/20 text-white shadow-lg shadow-indigo-950/35'
                          : 'bg-white/75 border-indigo-200/70 text-indigo-900 hover:bg-white'
                        }`}
                    >
                      {staffMember.Name} - {staffMember.Role}
                    </button>
                  ))}
                </div>

                {/* Display selected shout-out staff members */}
                {formData.shout.length > 0 && (
                  <div className="mt-4">
                    <h3 className="font-semibold text-lg"> Shout-out</h3>
                    <ul className="list-disc ml-6">
                      {formData.shout.map((staff, index) => (
                        <li key={index} className="text-gray-700">{staff}</li>
                      ))}
                    </ul>
                  </div>
                )}



              </div>
            </div>
            <div>
              <label htmlFor="Pinned" className="block text-sm font-semibold text-gray-700 mb-1">
                Pinned
              </label>
              <select onChange={handleChange}
                id="Pinned"
                name="Pinned"
                required
                className="w-full rounded-2xl border border-white/45 bg-white/90 px-4 py-2 text-gray-900 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              >
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>

            </div>




            {/* Type */}
            <div>
              <label htmlFor="type" className="block text-sm font-semibold text-gray-700 mb-1">
                Type
              </label>
              <select onChange={handleChange}
                id="type"
                name="type"
                required
                className="w-full rounded-2xl border border-white/45 bg-white/90 px-4 py-2 text-gray-900 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-sm focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              >
                <option value="news">News</option>
                <option value="bulletin">Help</option>
                <option value="bulletin">Bulletin</option>
                <option value="event">Event</option>
              </select>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-between gap-3">
              <button
                type="button"
                onClick={() => setPost(false)}
                className="flex-1 rounded-2xl border border-white/45 bg-white/80 py-2 text-indigo-900 shadow-[0_8px_20px_rgba(15,23,42,0.1)] hover:bg-white"
              >
                Close
              </button>
              <button
                type="submit"
                data-component="news-post-form"
                data-time-saved="2"
                data-feature="create_news_post"
                className="flex-1 rounded-2xl border border-white/20 bg-gradient-to-br from-indigo-900/90 via-sky-600/90 to-emerald-500/90 py-2 text-white shadow-[0_12px_28px_rgba(49,46,129,0.3)] hover:from-indigo-800/95 hover:via-sky-500/95 hover:to-emerald-400/95 focus:outline-none"
              >
                Submit
              </button>

            </div>
          </form>
          </div>
        </div>
      )}
      
      {!post && (
        <div className="w-full pb-6 sm:container sm:mx-auto sm:max-w-6xl">
          {/* Main Content */}
          <div className="px-3 pb-24 pt-4 sm:px-4 sm:py-6">
            {!postShow && selectedTab.name !== 'Product Hub' && (
              <div className="mb-6 text-center">
                <h2 className="text-xl font-medium text-indigo-800 sm:text-2xl">
                  {selectedTab.name} Posts
                </h2>
                <p className="mt-1 text-sm text-indigo-800">
                  Stay updated with the latest information and announcements
                </p>
              </div>
            )}
            
            {selectedTab.name === 'Product Hub' ? (
              <ProductHub />
            ) : (
              <div className="flex flex-col gap-6 md:flex-row">
                {/* Posts Feed - Main content */}
                <div className="flex-1 order-2 md:order-1">
                  <ul role="list" className="space-y-4">
              <div className="mx-auto mb-6 max-w-7xl px-0 sm:px-0 lg:px-0">
                <div className="overflow-hidden rounded-3xl border border-white/35 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl">
                  <h3 className="border-b border-indigo-200/60 px-4 py-3 text-lg font-semibold text-indigo-900">
                    People
                  </h3>
                  <div className="flex overflow-x-auto space-x-4 p-4 hide-scrollbar">
                    {/* Create a unique array of staff based on StaffId to avoid duplicates */}
                    {Array.from(new Map(posts.map(post => [post.StaffId, post])).values()).map((post, index) => (
                      <button
                        key={index}
                        onClick={() => handleProfileClick(post)}
                        className="relative flex-shrink-0 focus:outline-none group"
                      >
                        {/* Profile Picture with Status Dot */}
                        <div className="flex flex-col items-center">
                          <span className="relative inline-block">
                            <img
                              alt={`${post.StaffName}'s profile`}
                              src={getProfilePicSrc(post) || '/2.png'}
                              onError={(e) => { e.target.onerror = null; e.target.src = '/2.png'; }}
                              className="h-16 w-16 rounded-full border-2 border-white object-cover shadow-[0_8px_22px_rgba(15,23,42,0.22)]"
                            />

                            {/* Status Dot */}
                            <span
                              className={`absolute right-0 top-0 block h-4 w-4 rounded-full ring-2 ring-white ${
                                post.ClockedIn === 1 ? "bg-green-400" : "bg-red-400"
                              }`}
                            />
                          </span>
                          
                          {/* Name below avatar */}
                          <span className="mt-2 text-xs font-medium text-gray-700 text-center max-w-[70px] truncate">
                            {post.StaffName}
                          </span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              
              <style jsx>{`
                .hide-scrollbar::-webkit-scrollbar {
                  display: none;
                }
                .hide-scrollbar {
                  -ms-overflow-style: none;
                  scrollbar-width: none;
                }
              `}</style>

              {postShow && (
                <div className="flex justify-center p-2 rounded-lg bg-white shadow-lg inline-block">
                  <p className="text-2xl font-semibold font-bebas text-emerald-500">{postShow}</p>

                </div>
              )}



              {posts.map((post, index) => (
                <li
                  key={index}
                  className="mb-5 flex flex-col gap-0 overflow-hidden rounded-3xl border border-white/35 bg-white/85 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl"
                >
                  {/* Post Header - Author info */}
                  <div className="flex items-center border-b border-slate-200/70 bg-gradient-to-r from-indigo-50/70 via-white/90 to-sky-50/70 p-4">
                    <div className="flex-shrink-0 mr-3 relative">
                      <img
                        src={getProfilePicSrc(post) || '/2.png'}
                        onError={(e) => { e.target.onerror = null; e.target.src = '/2.png'; }}
                        alt={post.StaffName}
                        className="h-12 w-12 rounded-full border border-white object-cover shadow-[0_6px_16px_rgba(15,23,42,0.18)]"
                      />
                      {/* Online status indicator */}
                      <span
                        className={`absolute bottom-0 right-0 block h-3 w-3 rounded-full ring-2 ring-white ${
                          post.ClockedIn === 1 ? "bg-green-400" : "bg-red-400"
                        }`}
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-medium text-gray-900 truncate">
                        {post.StaffName} 
                        {post.Role && <span className="ml-1 text-xs text-gray-500">• {post.Role}</span>}
                      </p>
                      <p className="text-xs text-gray-500 truncate">
                        {format(new Date(post.CreatedAt), 'PPp')}
                      </p>
                    </div>
                    
                    {/* Pinned indicator */}
                    {post.Pinned === 1 && (
                      <div className="ml-auto flex items-center rounded-xl border border-red-200/70 bg-red-50 px-2 py-1 text-xs font-medium text-red-700">
                        <PaperClipIcon className="h-4 w-4 mr-1" />
                        Pinned
                      </div>
                    )}
                  </div>
                  
                  {/* Post Content */}
                  <div className="px-4 py-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {post.Title}
                    </h3>
                    {/* Post Content */}
                    <div className="text-sm text-gray-700">
                      {parseContent(post.Content)}
                    </div>
                    
                    {/* Shout-outs */}
                    {post.Shouts && post.Shouts !== "" && (
                      <div className="mt-3 flex flex-wrap gap-2">
                        {post.Shouts.split(',').map((shout, index) => (
                          <div key={index} className="inline-flex items-center gap-2 px-2 py-1 bg-indigo-50 text-indigo-700 rounded-full text-xs font-medium border border-indigo-100"> 
                            <UserCircleIcon className="h-4 w-4" />
                            <span>{shout}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Engagement Stats */}
                  <div className="flex items-center justify-between px-4 py-2 text-xs text-gray-500">
                    <div className="flex items-center">
                      <span className="flex items-center">
                        <HandThumbUpIcon className="h-4 w-4 mr-1 text-indigo-600 animate-bounce" />
                        {post.likes.length} {post.likes.length === 1 ? 'like' : 'likes'}
                      </span>
                    </div>
                    <div>
                      {post.comments.length > 0 && (
                        <span>{post.comments.length} {post.comments.length === 1 ? 'comment' : 'comments'}</span>
                      )}
                    </div>
                  </div>
                  
                  {/* Action Buttons */}
                  <div>
                    <div className="grid grid-cols-3" >
                      {post.likes.some(like => like.StaffId === user.id) ? (
                        <button
                          onClick={() => handleLike(post)}
                          type="button"
                          data-component="news-feed-actions"
                          data-feature="like_post_post"
                          className="flex items-center justify-center gap-1.5 py-3 text-sm font-semibold text-indigo-600 transition-colors hover:bg-indigo-50/70"
                        >
                          <HandThumbUpIcon className="h-5 w-5" />
                          <span>Liked</span>
                        </button>
                      ) : (
                        <button
                          onClick={() => handleLike(post)}
                          type="button"
                          data-component="news-feed-actions"
                          data-feature="like_post_post"
                          className="flex items-center justify-center gap-1.5 py-3 text-sm font-semibold text-indigo-600 transition-colors hover:bg-indigo-50/70"
                        >
                          <HandThumbUpIcon className="h-5 w-5" />
                          <span>Like</span>
                        </button>
                      )}

                      <button
                        onClick={() => setShowComments((prev) => (prev === post.PostId ? null : post.PostId))}
                        type="button"
                        className="flex items-center justify-center gap-1.5 py-3 text-sm font-semibold text-indigo-600 transition-colors hover:bg-indigo-50/70"
                      >
                        <ChatBubbleLeftIcon className="h-5 w-5" />
                        <span>Comment</span>
                      </button>
                      
                      <button
                        onClick={() => setShowLikes(!showLikes)}
                        type="button"
                        className="flex items-center justify-center gap-1.5 py-3 text-sm font-semibold text-indigo-600 transition-colors hover:bg-indigo-50/70"
                      >
                        <span>Who liked</span>
                        <ChevronDownIcon className="h-4 w-4 ml-1" />
                      </button>
                    </div>
                  </div>
                  {showComments === post.PostId && (
                    <div className="bg-gradient-to-b from-slate-50/80 to-white/95 py-3">
                      {/* Comments list */}
                      <div className="max-h-80 overflow-y-auto px-4">
                        {post.comments.length === 0 ? (
                          <p className="text-sm text-gray-500 py-3 text-center italic">Be the first to comment</p>
                        ) : (
                          <ul className="space-y-3">
                            {post.comments.map((comment, index) => (
                              <li key={index} className="flex">
                                {/* Avatar */}
                                <div className="flex-shrink-0 mr-3">
                                  <img
                                    src={getProfilePicSrc(comment) || '/2.png'}
                                    onError={(e) => { e.target.onerror = null; e.target.src = '/2.png'; }}
                                    alt={comment.StaffName}
                                    className="h-9 w-9 rounded-full object-cover border border-gray-200"
                                  />
                                </div>
                                {/* Comment content */}
                                <div className="flex-1 min-w-0">
                                  <div className="rounded-2xl border border-white/45 bg-white/90 px-3 py-2 shadow-[0_8px_18px_rgba(15,23,42,0.1)] backdrop-blur-xl">
                                    <p className="text-sm font-medium text-gray-900 mb-1">
                                      {comment.StaffName}
                                    </p>
                                    <div className="text-sm text-gray-700 break-words">
                                      {parseContent(comment.Content)}
                                    </div>
                                  </div>
                                  <div className="flex items-center mt-1 ml-2 space-x-3 text-xs">
                                    <span className="text-gray-500">
                                      {format(new Date(comment.CreatedAt), 'PPp')}
                                    </span>
                                    {comment.StaffId === user.id && (
                                      <button 
                                        onClick={() => handleDeleteComment(comment)}
                                        type="button"
                                        data-component="news-comment-actions"
                                        data-feature="delete_comment_delete"
                                        className="text-gray-500 hover:text-red-600 flex items-center"
                                      >
                                        <TrashIcon className="h-3 w-3 mr-1" />
                                        Delete
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      {/* Add comment input only when newComment === post.PostId */}
                      {newComment === post.PostId && (
                        <div className="bg-white/90 p-4 backdrop-blur-xl">
                          <form onSubmit={(e) => { e.preventDefault(); handleCommentSubmit(post); }} className="flex items-start">
                            <div className="flex-shrink-0 mr-3">
                              <img
                                src={user.profilePic || '/2.png'}
                                onError={(e) => { e.target.onerror = null; e.target.src = '/2.png'; }}
                                alt={user.firstName}
                                className="h-10 w-10 rounded-full object-cover border border-gray-200"
                              />
                            </div>
                            <div className="flex-1">
                              <textarea
                                name="comment"
                                placeholder="Write a comment..."
                                value={commentContent}
                                onChange={(e) => setCommentContent(e.target.value)}
                                className="block w-full rounded-2xl border border-white/45 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-500 shadow-[0_8px_18px_rgba(15,23,42,0.1)] focus:border-indigo-500 focus:ring-indigo-500"
                                rows={3}
                              />
                              <div className="mt-2 flex justify-end space-x-2">
                                <button
                                  type="button"
                                  onClick={() => { setNewComment(null); setCommentContent(''); }}
                                  className="inline-flex items-center rounded-xl border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="submit"
                                  disabled={!commentContent.trim()}
                                  data-component="news-comment-form"
                                  data-time-saved="2"
                                  data-feature="add_comment_post"
                                  className="inline-flex items-center rounded-xl border border-transparent bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-indigo-400"
                                >
                                  Post
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                      {/* Show add comment button if not already adding a comment */}
                      {newComment !== post.PostId && (
                        <div className="mt-2 border-t border-slate-200/70 px-4 pt-3">
                          <button
                            type="button"
                            className="block w-full rounded-full border border-slate-300 bg-white px-4 py-2 text-sm text-indigo-600 placeholder-gray-500 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            onClick={() => setNewComment(post.PostId)}
                          >
                            Add a comment...
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  {showLikes && (
                    <div className="rounded-b-3xl bg-white/95 p-3">
                      <h4 className="text-sm font-medium text-gray-700 mb-2">Liked by:</h4>
                      <div className="flex flex-wrap gap-1">
                        {post.likes.map((like, index) => (
                          <div key={index} className="flex items-center rounded-full border border-indigo-200/60 bg-indigo-50 px-3 py-1 text-xs text-indigo-700">
                            <UserCircleIcon className="h-3 w-3 mr-1" />
                            {like.StaffName}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                </li>
              ))}
                </ul>
              </div>
              
              {/* Staff Profile Section - Right sidebar */}
              <div className="w-full md:w-80 order-1 md:order-2 mb-6 md:mb-0">
                <div className="sticky top-28 overflow-hidden rounded-3xl border border-white/35 bg-white/85 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl">
                  {/* User Profile Card */}
                  <div className="bg-gradient-to-r from-indigo-900 via-sky-700 to-emerald-500 p-4">
                    <div className="flex items-center">
                      <img
                        src={user.profilePic || '/2.png'}
                        onError={(e) => { e.target.onerror = null; e.target.src = '/2.png'; }}
                        alt={user.firstName}
                        className="h-12 w-12 rounded-full border-2 border-white object-cover"
                      />
                      <div className="ml-3">
                        <h3 className="text-lg font-semibold text-white">{user.firstName} {user.lastName}</h3>
                        <p className="text-sm text-sky-100">{user.role}</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Stats */}
                  <div className="border-b border-slate-200/70 px-4 py-2">
                    <div className="flex justify-around">
                      <div className="text-center p-2">
                        <div className="font-medium text-gray-900">{posts.length}</div>
                        <div className="text-xs text-gray-500">Posts</div>
                      </div>
                      <div className="text-center p-2">
                        <div className="font-medium text-gray-900">{posts.reduce((total, post) => total + post.likes.length, 0)}</div>
                        <div className="text-xs text-gray-500">Likes</div>
                      </div>
                      <div className="text-center p-2">
                        <div className="font-medium text-gray-900">{posts.reduce((total, post) => total + post.comments.length, 0)}</div>
                        <div className="text-xs text-gray-500">Comments</div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Quick Actions */}
                  <div className="p-4">
                    <button
                      onClick={() => setPost(true)}
                      className="mb-2 flex w-full items-center justify-center rounded-2xl border border-indigo-200/60 bg-indigo-50 py-2 px-4 text-indigo-700 shadow-sm transition-colors hover:bg-indigo-100"
                    >
                      <PaperClipIcon className="h-5 w-5 mr-1.5" />
                      Create Post
                    </button>
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      )}

      {/* Mobile bottom bar */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 z-50">
        <div className="mx-3 mb-2 rounded-2xl border border-white/40 bg-white/85 backdrop-blur-xl shadow-[0_10px_30px_rgba(15,23,42,0.25)] px-2 py-1.5">
          <div className="flex items-center gap-3 overflow-x-auto hide-scrollbar">
          <button
            type="button"
            onClick={() => setPost(true)}
              className="flex flex-col items-center gap-1 text-[10px] font-semibold text-indigo-700 min-w-[72px]"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-600/90 text-white shadow-sm">
              <PaperAirplaneIcon className="h-4 w-4" />
            </span>
            Create
          </button>
          {tabs.map((tab) => {
            const Icon = mobileTabIcons[tab.name] || UserCircleIcon;
            const isActive = tab.name === selectedTab.name;
            return (
              <button
                key={`mobile-bottom-${tab.name}`}
                type="button"
                onClick={() => handleTabClick(tab)}
                  className={`flex flex-col items-center gap-1 text-[10px] font-semibold min-w-[72px] ${
                  isActive ? 'text-indigo-700' : 'text-gray-500'
                }`}
              >
                <span className={`flex h-9 w-9 items-center justify-center rounded-full transition-all ${
                  isActive
                    ? 'bg-indigo-100 text-indigo-700 animate-pulse'
                    : 'bg-white/80 text-gray-500 border border-white/60'
                }`}>
                  <Icon className="h-4 w-4" />
                </span>
                {tab.name}
              </button>
            );
          })}
          </div>
        </div>
      </div>
    </div>
  );
}
